import { useQuery } from '@tanstack/react-query';
import { pb } from '@/core/api';

type PipelineState = { enabled: boolean; isLoading: boolean };

export function usePipelineConfig(): PipelineState {
  const isAuth = !!pb.authStore.token;
  const { data, isLoading } = useQuery({
    queryKey: ['pipeline_enabled'],
    queryFn: async () => {
      try {
        const r = await pb.send('/api/config/public', { method: 'GET' });
        const v = r['pipeline_enabled'];
        return v === true || v === 'true';
      } catch {
        return false;
      }
    },
    enabled: isAuth,
    staleTime: 10_000,
    retry: 1,
  });
  return { enabled: data ?? false, isLoading: isLoading && isAuth };
}
